export default "__VITE_ASSET__C8YE4fZN__"